/**
 * store.js is where the Vuex is initialized, with the required store modules passed into it.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import {banner} from '@store/banner';
import {cate} from '@store/cate';
import {mainSite} from '@store/mainSite';
import {my_download_store} from '@store/my_download';
import {resource_store} from '@store/resource';
import {sample} from '@store/sample'; //TODO: for testing; to be removed
import {photo_gallery} from "@store/photo_gallery";

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        banner,
        cate,
        mainSite,
        my_download_store,
        resource_store,
        sample,
        photo_gallery
    }
})



// WEBPACK FOOTER //
// ./resources/assets/js/store/store.js